import React from 'react'
import about from 'assets/images/elaine (2).png'

function AboutUs() {
  return (
    <section id='quem-somos' className='flex w-full items-center justify-center bg-transparent'>
      <div className='container mx-auto my-16 flex w-11/12 flex-col items-center justify-center md:w-9/12'>
        <div className='flex flex-col md:flex-row md:items-center md:gap-16 lg:gap-24'>
          {/* Text Section */}
          <aside className='md:w-1/2'>
            <h2 className='text-4xl font-bold leading-tight text-gray-900 md:text-5xl'>Quem Somos?</h2>
            <p className='mt-6 text-lg leading-relaxed text-gray-700 md:text-xl'>
              Somos uma empresa especializada em soluções financeiras personalizadas, ajudando você a superar desafios e
              alcançar seus objetivos com total transparência e confiança.
            </p>
            <p className='mt-4 text-lg leading-relaxed text-gray-700 md:text-xl'>
              Com mais de 10 anos de experiência, nossa fundadora, Elaine Luciano do Nascimento Pianowski, garante nosso
              compromisso com a ética e responsabilidade. Priorizamos um atendimento próximo e personalizado, pois
              entendemos que cada cliente é único.
            </p>
          </aside>
          {/* Image Section */}
          <div className='mt-8 flex justify-center md:mt-0 md:w-1/2'>
            <img
              src={about}
              loading='lazy'
              alt='Imagem ilustrativa sobre quem somos'
              className='rounded-lg shadow-lg md:max-w-md'
            />
          </div>
        </div>

        {/* Mission, Vision, Values Section */}
        <div className='mt-16 grid grid-cols-1 gap-8 md:mt-20 md:grid-cols-3 md:gap-8 lg:gap-12'>
          {/* Mission */}
          <article className='relative flex flex-col items-center gap-4 rounded-lg bg-blue p-6 text-center text-white'>
            <h3 className='text-2xl font-semibold md:text-3xl'>Missão</h3>
            <p className='text-lg leading-relaxed md:text-xl'>
              Oferecer soluções financeiras confiáveis e transparentes para ajudar as pessoas a realizar seus sonhos e
              superar seus desafios financeiros.
            </p>
          </article>

          {/* Vision */}
          <article className='relative flex flex-col items-center gap-4 rounded-lg bg-blue p-6 text-center text-white'>
            <h3 className='text-2xl font-semibold md:text-3xl'>Visão</h3>
            <p className='text-lg leading-relaxed md:text-xl'>
              Ser reconhecida como a empresa líder em soluções financeiras na região, conhecida por sua ética,
              responsabilidade e excelência no atendimento ao cliente.
            </p>
          </article>

          {/* Values */}
          <article className='relative flex flex-col items-center gap-4 rounded-lg bg-blue p-6 text-center text-white'>
            <h3 className='text-2xl font-semibold md:text-3xl'>Valores</h3>
            <p className='text-lg leading-relaxed md:text-xl'>
              Honestidade, ética, responsabilidade, respeito e excelência.
            </p>
          </article>
        </div>
      </div>
    </section>
  )
}

export default AboutUs
